import { render, staticRenderFns } from "./sidebarItem.vue?vue&type=template&id=50d2e0eb&scoped=true"
import script from "./sidebarItem.vue?vue&type=script&lang=ts"
export * from "./sidebarItem.vue?vue&type=script&lang=ts"
import style0 from "./sidebarItem.vue?vue&type=style&index=0&id=50d2e0eb&prod&lang=scss"
import style1 from "./sidebarItem.vue?vue&type=style&index=1&id=50d2e0eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d2e0eb",
  null
  
)

export default component.exports